// extracted by mini-css-extract-plugin
module.exports = {"content":"e2ff468f85--content--VSTEw"};